import styled, { createGlobalStyle } from "styled-components";

import ChampionsWebRegular from "./font/ChampionsWeb-Regular.woff2";
import CountachBold from "./font/Countach_Bold.otf";
import SinterRegular from './font/Sinter_Regular.otf';

export const ChampionsWebRegularFont = createGlobalStyle`
@font-face {
  font-family: "ChampionsWebRegular";
  src: url(${ChampionsWebRegular}) format("woff2");
  font-style: normal;
  font-display: auto;
}
`;

export const CountachBoldFont = createGlobalStyle`
@font-face {
  font-family: "CountachBold";
  src: url(${CountachBold}) format("opentype");
  font-style: bold;
  font-display: auto;
}
`;

export const SinterRegularFont = createGlobalStyle`
@font-face {
  font-family: "SinterRegular";
  src: url(${SinterRegular}) format("opentype");
  font-style: normal;
  font-display: auto;
}
`;

export const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: #010056;
  justify-content: flex-start;
  .banner {
    width: 100%;
    height: 134px;
    object-fit: cover;
  }

  h1 {
    color: #fff;
    text-align: center;
    font-family: "CountachBold";
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 142.857% */
  }

  p {
    color: #fff;
    text-align: center;
    font-family: "SinterRegular";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
  }
`;

export const Navbar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 8px;
  padding: 16px 20px;
  border-bottom: 1px solid #000;
  background: #fff;

  img {
    height: 51px;
  }
  .balance-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }
  .balance-text {
    color: #fff;
    font-family: "SinterRegular";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 100% */
    letter-spacing: 0.15px;
    color: #d71921;
    text-align: right;
  }
  .balance-value {
    color: #fff;
    font-family: "SinterRegular";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 100% */
    letter-spacing: 0.15px;
    color: #d71921;
  }
`;

export const ContentContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 24px;
  width: 100%;
  align-self: stretch;

  .highlight-text {
    color: #7fbbea;
  }
  a {
    font-weight: 500;
    font-family: "SinterRegular";
    text-decoration: underline;
    color: #fff;
  }
  img {
    width: 100%;
    height: auto;
  }
`;

export const ButtonsSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0px;
  gap: 16px;
  background: #000b83;
  img {
    height: 60px;
    cursor: pointer;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px;
  gap: 8px;
  background: #000b83;

  img {
    height: 33px;
  }

  .powered-by {
    color: #fff;
    font-family: "Inter";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
  }

  a {
    color: #fff;
    font-family: "Inter";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
  }

  .copyToClipboard {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    img {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
`;
